import isEmpty from 'lodash.isempty';

import useLocaleWithFallback from '@app/hooks/useLocaleWithFallback';

import type { PricingPageShopProduct_magento2_products_items_Magento2_ConfigurableProduct_variants as Variant } from '../../hook/__generated__/PricingPageShopProduct';
import { useGetRequiredBaseProductsQuery } from './__graphql__/LicenseSelector';

interface useLicenseSelectorMessagesProps {
  variants: (Variant | null)[];
  selectedVariant: Variant | null;
}

const useLicenseSelectorMessages = ({
  variants,
  selectedVariant,
}: useLicenseSelectorMessagesProps) => {
  const { getLanguagesWithFallback } = useLocaleWithFallback();
  const isSingleLicenseProduct = variants?.length === 1;

  const { data: requiredBaseProducts } = useGetRequiredBaseProductsQuery({
    skip: isSingleLicenseProduct,
    variables: {
      languages: getLanguagesWithFallback(),
      skus: variants?.map((varr) => varr?.product?.sku || ''),
    },
  });

  const variantsWithRequiredBaseProducts =
    requiredBaseProducts?.content?.required_base_products
      .filter(({ messages }) => !isEmpty(messages))
      .map(({ sku }) => sku);

  const selectedVariantHasRequiredProducts =
    variantsWithRequiredBaseProducts?.includes(
      selectedVariant?.product?.sku || '',
    );

  const ownershipMessagesByVariant =
    requiredBaseProducts?.content?.required_base_products.find(
      (product) => product.sku === selectedVariant?.product?.sku,
    )?.messages;

  return {
    ownershipMessagesByVariant,
    selectedVariantHasRequiredProducts,
    variantsWithRequiredBaseProducts,
  };
};

export default useLicenseSelectorMessages;
